import { CommonKeys } from "../../../common/enums";
import { STAMM_ANLAGE_TYPE } from "../../interfaces/stammelements/StammElementAnlage";

export const FormularGroupStammStammElementAnlageSchema = {
    $id: "FormularGroupStammStammElementAnlageSchema",
    title: "FormularGroupStammStammElementAnlage Schema",
    type: "object",
    allOf: [
        { $ref: "FormularGroupStammStammElementBaseSchema" },
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: STAMM_ANLAGE_TYPE },
                Property: { type: "number", nullable: true }
            }
        }
    ],
};